import RecordSelector from "./RecordSelector";

interface AnnouncementSelectorProps {
  name: string;
}

export default function AnnouncementSelector({
  name,
}: AnnouncementSelectorProps) {
  const formatOptionLabel = (option: any) => {
    return (
      <div>
        <div className="font-medium">{option.label}</div>
        {option.description && (
          <div className="text-sm text-gray-600">{option.description}</div>
        )}
      </div>
    )
  };

  return (
    <RecordSelector
      name={name}
      isMulti={false}
      searchUrl="/admin/announcements/search"
      label="Announcement"
      formatOptionLabel={formatOptionLabel}
      manageUrl="/admin/announcements"
      manageLabel="Manage or create announcements"
    />
  )
}
